// Business page: each client's payout account status (read only). Clients set
// up their own payout account from the Client Portal.
import React, { useEffect, useState } from 'react';
import clientPortalAPI from './clientPortalApi';
import { formatApiError } from '../../utils/errorMessage';

const LABEL = { not_set_up: 'Not set up', pending: 'Setup in progress', active: 'Ready for payouts' };

export default function ClientPayoutAccounts({ businessId }) {
  const [rows, setRows] = useState(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let live = true;
    clientPortalAPI.payoutAccounts(businessId)
      .then((r) => { if (live) setRows(r.data.accounts); })
      .catch((e) => { if (live) setError(formatApiError(e, 'Could not load payout accounts')); });
    return () => { live = false; };
  }, [businessId]);
  if (error) return <p role="alert" className="text-red-600 text-xs">{error}</p>;
  if (!rows || rows.length === 0) return null;
  return (
    <div aria-label="Client payout accounts" className="border rounded p-2">
      <p className="font-medium text-xs mb-1">Client payout accounts</p>
      <ul className="text-xs">
        {rows.map((r) => (
          <li key={r.portal_client_id}>{r.display_name || r.email}: {LABEL[r.status] || r.status}{r.test_mode ? ' (test)' : ''}</li>
        ))}
      </ul>
    </div>
  );
}
